export const grayScale = {
    DEFAULT: '#B8B8B8',
    50: '#F9F9F9',
    100: '#F4F5F5',
    200: '#EAEBEB',
    300: '#DADBDB',
    400: '#B8B8B8',
    500: '#929191',
    600: '#707070',
    700: '#575757',
    800: '#484848',
    900: '#333333',
    950: '#242424',
    1000: '#1A1A1A',
    1025: '#141414',
    1050: '#0D0D0D'
};
export const redScale = {
    DEFAULT: '#E14E4E',
    light: '#F59999',
    dark: '#B22D2D',
    100: '#FCD4D4',
    200: '#FBBBBB',
    300: '#F59999',
    400: '#EE7272',
    500: '#E14E4E',
    600: '#B22D2D',
    700: '#891A1A',
    800: '#6C0F0F',
    900: '#530909',
    1000: '#320606'
};
export const orangeScale = {
    DEFAULT: '#F38C16',
    light: '#FDCF9B',
    dark: '#CC7410',
    100: '#FEE5C7',
    200: '#FDCF9B',
    300: '#FCB769',
    400: '#F38C16',
    500: '#CC7410',
    600: '#9D5707',
    700: '#764105',
    800: '#532E03',
    900: '#3B2102',
    1000: '#271602'
};
export const yellowScale = {
    DEFAULT: '#EBBE0A',
    light: '#FFEB99',
    dark: '#EBBE0A',
    100: '#FFF4C7',
    200: '#FFEB99',
    300: '#FAD957',
    400: '#EBBE0A',
    500: '#BA9608',
    600: '#846B06',
    700: '#624F04',
    800: '#453703',
    900: '#312802',
    1000: '#221C01'
};
export const tealScale = {
    DEFAULT: '#33CCB8',
    light: '#8AE2D6',
    dark: '#29A393',
    100: '#C5F9F2',
    200: '#A6F2E8',
    300: '#8AE2D6',
    400: '#33CCB8',
    500: '#29A393',
    600: '#137669',
    700: '#095349',
    800: '#073C35',
    900: '#052E28',
    1000: '#04201C'
};
export const blueScale = {
    DEFAULT: '#38A5FF',
    100: '#EFF8FF',
    150: '#DFF0FD',
    200: '#CFE8FC',
    300: '#85C8FF',
    400: '#38A5FF',
    500: '#128DF2',
    600: '#006FCC',
    700: '#004C9D',
    800: '#003474',
    900: '#00265B',
    1000: '#001533'
};
export const steelBlueScale = {
    DEFAULT: '#9AA5B2',
    100: '#F0F4F7',
    200: '#DFE5EB',
    300: '#B8C1CC',
    400: '#9AA5B2',
    500: '#768494',
    600: '#5D6A7A',
    700: '#475566',
    800: '#354252',
    900: '#19222E',
    950: '#10171F',
    1000: '#0B1117'
};
/**
 * @deprecated use `steelBlueScale` instead
 */
export const blueSteelScale = steelBlueScale;
export const steelGrayScale = {
    DEFAULT: '#A6ADB2',
    100: '#F0F4F7',
    200: '#E4E8EB',
    300: '#C5CCD1',
    400: '#A6ADB2',
    500: '#858E94',
    600: '#656F76',
    700: '#525D66',
    800: '#404A52',
    850: '#303940',
    900: '#1F272E',
    950: '#141A1F',
    1000: '#0E1317'
};
//# sourceMappingURL=color_palette.js.map